import { render } from "./tablePart.vue?vue&type=template&id=1172ba1a"
import script from "./tablePart.vue?vue&type=script&lang=js"
export * from "./tablePart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__